import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { waterInfoData } from './waterInfo.data'

interface IWaterInfoState {
  markdown: { [key: string]: string[] }
  selectedWaterParameter: string
  open: boolean
}

const initialState:IWaterInfoState = {
  markdown: waterInfoData,
  selectedWaterParameter: '',
  open: false,
}

const waterInfoSlice = createSlice({
  name: 'waterInfo',
  initialState,
  reducers: {
    setSelectedWaterParameter: (state, action: PayloadAction<string>) => {
      state.selectedWaterParameter = action.payload
    },
    toggleIsOpen: (state) => {
      state.open = !state.open
    },
  },
})

export const WaterInfoActions = {
  ...waterInfoSlice.actions,
}

export const WaterInfoReducer = waterInfoSlice.reducer
